import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { BaseDOM } from "../base.dom";

export class PointagePause extends BaseDOM<PointagePause> {
    @AutoMap()
    Debut!: Temporal.PlainDateTime;
    @AutoMap()
    Fin!: Temporal.PlainDateTime;

}